import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=3b5494dd&"
import script from "./Boards.vue?vue&type=script&lang=ts&"
export * from "./Boards.vue?vue&type=script&lang=ts&"
import style0 from "./Boards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports